<template>
  <v-card>
    <div v-bind:class = "(stroll.image)?'image-close-preview-button':'no-image-close-preview-button'">
      <v-btn v-on:click="$emit('hidePreview')" class="mx-0" color="secondary">Close</v-btn>
    </div>
    <image-with-fullscreen-dialog
      v-if="stroll.image"
      :fullscreen-image="stroll.image.meta.download_url"
      :preview-image="stroll.image_card_large.url"
      :title="stroll.title"
      :aspect-ratio="2"
    />
    <v-card-title primary-title>
      <stroll-avatar :stroll="stroll" />
      <div>
        <h3>
          {{ stroll.title }}
        </h3>
        <div class="mt-2">
          <stroll-categories :categories="stroll.categories" />
        </div>
      </div>
    </v-card-title>
    <v-card-text v-html="stroll.description" />
    <v-card-text v-if="stroll.in_person_enabled">
      <stroll-in-person-message :stroll="stroll" message-tag="div" />
    </v-card-text>
    <div v-if="stroll.preview_media">
      <v-card-title>
        <h3>Preview</h3>
      </v-card-title>
      <v-card-text>
        <div v-html="stroll.preview_description" />
        <media :media="stroll.preview_media" />
      </v-card-text>
    </div>
    <v-card-actions>
      <v-btn
        :to="{name: 'stroll', params: {strollId: stroll.id}}"
        flat
        color="primary"
      >
        {{ strollWording }}
      </v-btn>
      <v-btn
        flat
        :to="{name: 'directions', params: {strollId: stroll.id}}"
      >
        Directions
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style>
.image-close-preview-button{
  position: absolute;
  left: 10px;
  top: 5px;
  height: 0px;
  z-index: 10;
}
.no-image-close-preview-button{
  padding: 10px;
}
</style>

<script>
import { mapGetters } from 'vuex'
import Media from '@/components/Media.vue'
import StrollAvatar from '@/components/StrollAvatar.vue'
import StrollCategories from '@/components/StrollCategories.vue'
import StrollInPersonMessage from '@/components/StrollInPersonMessage.vue'
import ImageWithFullscreenDialog from '@/components/ImageWithFullscreenDialog.vue'

export default {
  name: 'StrollPreview',

  components: {
    ImageWithFullscreenDialog,
    Media,
    StrollAvatar,
    StrollCategories,
    StrollInPersonMessage,
  },

  model: {
    event: 'change',
  },

  props: {
    stroll: {
      type: Object
    },
  },

  computed: {
    ...mapGetters({
      strollWording: 'getStrollWording',
    }),
  },

}
</script>
